(() => {
  'use strict';
  const scope = '[data-bqc-real-media]';
  const players = scope + ' [data-bqc-real-player] video';
  const fail = card => {
    const status = card.querySelector('[data-bqc-real-status]');
    if (status) status.textContent = 'No se ha podido reproducir el vídeo. Usa el enlace «Abrir vídeo» para abrirlo directamente.';
  };
  const pauseOthers = current => {
    document.querySelectorAll(players).forEach(video => {
      if (video !== current && !video.paused) video.pause();
    });
  };
  document.querySelectorAll(scope).forEach(root => {
    if (root.dataset.bqcRealReady) return;
    root.dataset.bqcRealReady = 'true';
    root.querySelectorAll('[data-bqc-real-player]').forEach(card => {
      const video = card.querySelector('video');
      const button = card.querySelector('[data-bqc-real-play]');
      if (!video || !button) return;
      video.addEventListener('error', () => fail(card));
      video.addEventListener('play', () => pauseOthers(video));
      button.addEventListener('click', () => {
        if (button.disabled) return;
        button.disabled = true;
        button.hidden = true;
        const poster = card.querySelector('[data-bqc-real-poster]');
        if (poster) poster.hidden = true;
        video.hidden = false;
        video.focus({ preventScroll: true });
        try {
          const url = new URL(video.getAttribute('data-src'));
          if (url.protocol !== 'https:' || url.username || url.password) throw new Error('URL');
          pauseOthers(video);
          video.src = url.href;
          video.load();
          const play = video.play();
          if (play && typeof play.catch === 'function') play.catch(() => fail(card));
        } catch (_) {
          fail(card);
        }
      });
      button.hidden = false;
    });
  });
})();
